import { JSX } from "react";

import {
  ComponentsOverride,
  CpqCore,
  OverridableComponentsKeys,
  StandardComponents,
} from "@4pace-cpq/core";

import { AppHeader } from "./components/AppHeader/AppHeader";
import { CustomCartIdRouteComponent } from "./components/CustomCartIdRouteComponent/CustomCartIdRouteComponent";
import ConfiguratorContainer from "./configurator/ConfiguratorContainer";
import { CustomIndexRouteComponent } from "./cpq/overrides/CustomIndexRouteComponent/CustomIndexRouteComponent";
import { CustomOpportunityRouteComponent } from "./cpq/overrides/CustomOpportunityRouteComponent/CustomOpportunityRouteComponent";
import QuoteDetailsViewPageHeader from "./cpq/overrides/QuoteDetailsViewPageHeader/QuoteDetailsViewPageHeader";
import { prettyLogger } from "./prettyLogger";
import { useEasySession } from "./providers/easySessionProvider";
import { customPalette } from "./theme/theme";

prettyLogger(
  `FE Version ${__CPQ_CORE_FE_VERSION__}`,
  customPalette.primary.main,
);

export function App(): JSX.Element {
  const { isEasySessionInit } = useEasySession();

  if (isEasySessionInit) {
    return <></>;
  }

  const componentsOverride: ComponentsOverride = {
    [OverridableComponentsKeys.QuoteDetailsViewPageHeader]:
      QuoteDetailsViewPageHeader,
    [OverridableComponentsKeys.MainHeader]: () => <AppHeader />,
    [OverridableComponentsKeys.GoBackToOpportunitiesButton]: () => <></>,
    [OverridableComponentsKeys.ConfiguratorRouteComponent]: () => (
      <ConfiguratorContainer />
    ),

    [OverridableComponentsKeys.OpportunityRouteComponent]: () => (
      <CustomOpportunityRouteComponent />
    ),
    [OverridableComponentsKeys.QuotesRouteComponent]: () => (
      <div>
        <StandardComponents.QuotesRouteComponent />
      </div>
    ),
    [OverridableComponentsKeys.CartIdRouteComponent]: () => (
      <CustomCartIdRouteComponent />
    ),

    [OverridableComponentsKeys.IndexRouteComponent]: CustomIndexRouteComponent,
    [OverridableComponentsKeys.AppInitializer]: () => null,
  };

  return <CpqCore componentsOverride={componentsOverride} />;
}
